var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 70,
    viewBox: "0 0 52 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2939 0.604126C12.1246 0.604126 0.54541 12.117 0.54541 26.3749C0.54541 32.0172 2.29739 37.3543 5.64939 41.7764L26.2177 69.2246L46.786 41.7764C50.138 37.2781 51.89 31.9411 51.89 26.3749C52.043 12.1171 40.4637 0.604126 26.2939 0.604126ZM26.2939 48.2572C14.1816 48.2572 4.35435 38.4219 4.35435 26.2987C4.35435 14.252 14.1817 4.41638 26.2939 4.41638C38.406 4.41638 48.2334 14.2517 48.2334 26.3749C48.2334 38.4216 38.406 48.2572 26.2939 48.2572Z",
    fill: "#0F5671"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8927 23.4777V16.3871H30.8653V18.4459L27.8943 15.4723C26.9803 14.5576 25.5329 14.5576 24.6948 15.4723L12.049 28.0525C11.6679 28.4338 11.4395 28.9673 11.4395 29.5773C11.4395 30.1112 11.6679 30.7207 12.049 31.102C12.43 31.4833 12.9629 31.712 13.5724 31.712C14.1059 31.712 14.7149 31.4833 15.0958 31.102L16.6959 29.5006V38.8025H24.7707V32.5501L27.8176 32.5507V38.803H35.969V29.5006L37.569 31.102C37.95 31.4833 38.483 31.712 39.0925 31.712C39.626 31.712 40.2349 31.4833 40.6159 31.102C40.9969 30.7207 41.2254 30.1872 41.2254 29.5772C41.2254 28.9673 40.9969 28.4338 40.6159 28.0525L35.8927 23.4777Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMarker);
export default __webpack_public_path__ + "static/media/active-marker.79dc51a3ebd6a3ddcd84596413584db6.svg";
export { ForwardRef as ReactComponent };